export default __webpack_public_path__ + "static/media/menu.4b4c5d3c.svg";